import type { Viewport } from '../types';

/** One tile of the dot grid in screen pixels: tile size, where the grid starts, and the dot radius. */
export type DotPattern = { tileSize: number; offsetX: number; offsetY: number; radius: number };

const HALF = 0.5;

/** The dot grid for a viewport: spacing and dots scale with the zoom, the grid moves with the pan (v11 look). */
export const getDotPattern = ({ x, y, zoom }: Viewport, gap: number, size: number): DotPattern => {
  const tileSize = gap * zoom;
  return { tileSize, offsetX: x % tileSize, offsetY: y % tileSize, radius: size * zoom * HALF };
};
